import { render, staticRenderFns } from "./UserProfileHeader.vue?vue&type=template&id=b88c33d6&scoped=true"
import script from "./UserProfileHeader.vue?vue&type=script&lang=js"
export * from "./UserProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./UserProfileHeader.vue?vue&type=style&index=0&id=b88c33d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88c33d6",
  null
  
)

export default component.exports